import { render, staticRenderFns } from "./recap-calendar.vue?vue&type=template&id=3578bc88&"
import script from "./recap-calendar.vue?vue&type=script&lang=ts&"
export * from "./recap-calendar.vue?vue&type=script&lang=ts&"
import style0 from "./recap-calendar.vue?vue&type=style&index=0&id=3578bc88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports